export default __webpack_public_path__ + "static/media/Banner@1x.png?.0e7710b1";